/**
 * AnorBank super app (`anorbank.insonuchun.uz`) host adapter — `definePathParamHost`
 * factory orqali, Paynet bilan bir xil model.
 *
 * AnorBank mini app'ni imzolangan tokenni URL YO'LIGA joylab ochadi:
 *
 *     https://anorbank.insonuchun.uz/anorbank/login/<token>
 *
 * Mini app shu tokenni path'dan olib `/MiniApp/AnorbankLogin` ga `{ token }` bo'lib
 * jo'natadi va javobdagi JWT'ni sessionStorage'ga saqlaydi. Javob kengaytirilgan
 * `VendorLoginResponse` shaklida (nested `user`) — factory `mapVendorResponse`
 * bilan normalizatsiya qiladi.
 *
 * Javobda `theme` ("dark" | "light") ham keladi; uni `persistPreferredTheme`
 * orqali localStorage'ga yozamiz — `getInitialTheme()` (useTheme) shu kalitni
 * o'qigani uchun mavzu boot'da avtomatik qo'llanadi (theme boot'iga tegilmaydi).
 */

import { persistPreferredTheme } from "@/lib/env";
import { definePathParamHost } from "./pathParamHost";

export const anorbankHost = definePathParamHost({
  id: "anorbank",
  brandId: "anorbank",
  hostnames: ["anorbank.insonuchun.uz"],
  loginEndpoint: "/MiniApp/AnorbankLogin",
  pathPrefix: "/anorbank/login/",
  payloadKey: "token",
  onLoginResponse: (raw) => persistPreferredTheme(raw.theme),
});
